import { useCallback, useState } from "react";

import { LoanInfoSorting, LoanPaginationInfo, LoanStatusType, LoopPositionExpanded } from "@bridgesplit/abf-react";
import { isAll, SortDirection } from "@bridgesplit/utils";

import { useChunkedPaginationController } from "./shared";

const DEFAULT_PAGE_SIZE = 5;
const DEFAULT_SORT_SIDE = SortDirection.Desc;
const DEFAULT_SORT_TYPE = LoanInfoSorting.NetPositionValue;

/** Same shape as loans API (LoanPaginationInfo); loops use different defaults. */
export function useLoopsPagination() {
    const [sortSide, setSortSide] = useState<SortDirection>(DEFAULT_SORT_SIDE);
    const [sortType, setSortType] = useState<LoanInfoSorting>(DEFAULT_SORT_TYPE);
    const [loanStatusType, setLoanStatusType] = useState<LoanStatusType>(LoanStatusType.ActiveOnly);
    const [principalMint, setPrincipalMint] = useState<string | undefined>(undefined);
    const [collateralMint, setCollateralMint] = useState<string | undefined>(undefined);

    const chunkedPagination = useChunkedPaginationController<LoopPositionExpanded, LoanPaginationInfo>(
        {
            sortSide,
            sortType,
            loanStatusType,
            principalMint: isAll(principalMint) ? undefined : principalMint,
            collateralMint: isAll(collateralMint) ? undefined : collateralMint
        },
        DEFAULT_PAGE_SIZE
    );

    const reset = useCallback(() => {
        setSortSide(DEFAULT_SORT_SIDE);
        setSortType(DEFAULT_SORT_TYPE);
        setLoanStatusType(LoanStatusType.ActiveOnly);
        setPrincipalMint(undefined);
        setCollateralMint(undefined);
        chunkedPagination.resetPagination();
    }, [chunkedPagination]);

    return {
        ...chunkedPagination,
        params: chunkedPagination.clientPagination,
        setSortSide,
        setSortType,
        setLoanStatusType,
        setPrincipalMint,
        setCollateralMint,
        reset
    };
}
